
import React, { useState } from 'react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { PanelSectionTitle } from '../../core';

const ShareOption = (props) => {

    const classNames = mergeStyleSets({
        root: {
            paddingBottom: 2
        }
    });

    const handleChange = (event, checked) => {
        props.onChange(props.option.name, checked);
    }

    return (
        <div className={classNames.root}>
            <Checkbox
                label={props.option.title}
                checked={props.checked && !props.disabled}
                disabled={props.disabled}
                onChange={handleChange}
            />
        </div>
    );
}

const ShareOptions = (props) => {

    const classNames = mergeStyleSets({
        root: {
        },
    });

    const OPTIONS = [
        {name: 'center', title: 'Použít aktuální střed mapového okna'},
        {name: 'zoom', title: 'Použít aktuální zvětšení mapového okna'},
        {name: 'layers', title: 'Použít aktuální zapnuté vrstvy'},
        {name: 'mms', title: 'Použít otevřené 3D okno', disabled: !props.visibleMultiScene}
    ];

    const [options, setOptions] = useState({});

    const handleChange = (name, checked) => {
        let newOptions = {
            ...options,
            [name]: checked
        };
        props.onChange(newOptions);
        setOptions(newOptions);
    }

    return (
        <div className={classNames.root}>
            <PanelSectionTitle title="Možnosti pro generování URL adresy" />
            {OPTIONS.map(item => {
                return (
                    <ShareOption
                        key={item.name}
                        option={item}
                        checked={(options[item.name] === true)}
                        disabled={item.disabled}
                        onChange={handleChange}
                    />
                );
            })}
        </div>
    );
}

export default ShareOptions;
